// @flow
import { all, call, put, takeEvery } from 'redux-saga/effects';
import { tripica } from '../../api';
import type { NextPlanActionType } from './actions';
import { setNextPlan } from './actions';
import { injectMockRoamingNextPlanOptions } from '../../lib/mockRoamingOptions';
import WizzeeLog from '../../lib/wizzeeLog';

export function* fetchNextPlanSaga(action: NextPlanActionType): Generator<*, *, *> {
  if (action.type !== 'FETCH_NEXT_PLAN') return; // for flow
  const { subscription } = action.payload;

  try {
    const nextPlan = yield call([tripica, 'getNextPlan'], subscription.id);
    const enrichedNextPlan = injectMockRoamingNextPlanOptions(nextPlan);
    yield put(setNextPlan(enrichedNextPlan));
  } catch (error) {
    WizzeeLog.warn('[saga] fetchNextPlanSaga', error);
  }
}

export default function*(): Generator<*, *, *> {
  yield all([takeEvery('FETCH_NEXT_PLAN', fetchNextPlanSaga)]);
}
